"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialsConfig = void 0;
var server_1 = __importDefault(require("react-dom/server"));
var react_1 = __importDefault(require("react"));
var partiallyApplyComponent_1 = __importDefault(require("@CommonFrontend/QuoteV2/Components/partiallyApplyComponent"));
var Initials_1 = __importDefault(require("@CommonFrontend/Public/Widgets/Initials"));
var styles = __importStar(require("@CommonFrontend/Public/Widgets/Initials/Initials.css"));
exports.InitialsConfig = {
    type: "initials",
    tokenType: {},
    publicRender: function InitialsWidget(_a) {
        var attributes = _a.attributes, isPrintMode = _a.isPrintMode;
        return server_1.default.renderToString(react_1.default.createElement((0, partiallyApplyComponent_1.default)(Initials_1.default, {
            attributes: attributes,
            isPrintMode: isPrintMode,
        })));
    },
    traits: {
        spacingShim: {
            className: styles.spacingShim,
        },
    },
};
